"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useColorbar;
var _react = require("react");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var initialPaletteData = {
  data: [],
  // Uint8ClampedArray(28800)
  width: 15,
  height: 480,
  colorSpace: "srgb"
};
function useColorbar(initialData) {
  var _useState = (0, _react.useState)(initialData || initialPaletteData),
    _useState2 = _slicedToArray(_useState, 2),
    paletteData = _useState2[0],
    setPaletteData = _useState2[1];
  var colorbar = (0, _react.useMemo)(function () {
    /**
     * returns the compatible rgba array used in a css linear-gradient
     * colorbar length: 28800 / (15 * 4) = 480
     * example use:     `linear-gradient(1turn, ${colorBar})`;
     */
    var _ref = paletteData || {},
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 480 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 15 : _ref$width;

    // exit early
    if (data.length < 1) return "#00f, #f00";
    var colorStops = [];
    // Row-Major Order:
    for (var i = 0; i < data.length; i += 4 * width) {
      var r = data[i];
      var g = data[i + 1];
      var b = data[i + 2];
      var s = 1 || +(data[i + 3] / 255).toFixed(3);
      var percentage = +(100 * (i / (width * 4)) / height).toFixed(3);
      colorStops.push("rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(s, ") ").concat(percentage, "%"));
    }
    return "linear-gradient(to bottom, ".concat(colorStops.join(", "), ")");
  }, [paletteData]);
  return [colorbar, setPaletteData];
}